import { __extends } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { BuyerNeedsModel } from '@apto/models';
import { BuyerNeedsService } from '@apto/services';
import { TOAST_DURATION } from '@apto/ionic-lib/constants';
import { BaseSlideModal } from '@apto/shared/modals';
import { EditBuyerNeedForm } from '@apto/shared/components';
import './buyer-needs-modal.scss';
export var BuyerNeedsModalMode = /*@__PURE__*/ (function (BuyerNeedsModalMode) {
    BuyerNeedsModalMode[BuyerNeedsModalMode["LIST"] = 0] = "LIST";
    BuyerNeedsModalMode[BuyerNeedsModalMode["VIEW"] = 1] = "VIEW";
    BuyerNeedsModalMode[BuyerNeedsModalMode["EDIT"] = 2] = "EDIT";
    return BuyerNeedsModalMode;
})({});
var BuyerNeedsModal = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(BuyerNeedsModal, _super);
    function BuyerNeedsModal(buyerNeedsService, navParams, toastController, viewController) {
        var _this = _super.call(this, viewController, navParams) || this;
        _this.buyerNeedsService = buyerNeedsService;
        _this.toastController = toastController;
        _this.isLoadingBuyerNeeds = false;
        _this.modalUrls = new Map([
            [BuyerNeedsModalMode.VIEW, '/:buyerNeedsId']
        ]);
        _this.Modes = BuyerNeedsModalMode;
        _this.records = [];
        _this.selectedRecord = new BuyerNeedsModel();
        _this.mode = _this.navParams.get('mode') || BuyerNeedsModalMode.LIST;
        _this.records = _this.navParams.get('records') || [];
        _this.selectedRecord = _this.navParams.get('selectedRecord') || new BuyerNeedsModel();
        return _this;
    }
    BuyerNeedsModal.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.editBuyerNeedForm.loadingMessage = 'Deleting buyer\'s need...';
                        return [4 /*yield*/, this.buyerNeedsService.delete([this.selectedRecord._id])];
                    case 1:
                        _a.sent();
                        this.showToast("Deleted " + this.selectedRecord.name + ".");
                        this.dismiss();
                        return [2 /*return*/];
                }
            });
        });
    };
    BuyerNeedsModal.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formResult, buyerNeedToUpsert, savedBuyerNeed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formResult = this.editBuyerNeedForm.save();
                        if (!(formResult && formResult.buyerNeed))
                            return [3 /*break*/, 2];
                        this.scrollToTop();
                        this.editBuyerNeedForm.loadingMessage = 'Saving buyer\'s need...';
                        buyerNeedToUpsert = new BuyerNeedsModel();
                        Object.assign(buyerNeedToUpsert, formResult.buyerNeed);
                        return [4 /*yield*/, this.buyerNeedsService.upsert(buyerNeedToUpsert)];
                    case 1:
                        savedBuyerNeed = _a.sent();
                        this.editBuyerNeedForm.loadingMessage = null;
                        if (this.initialMode === this.Modes.EDIT) {
                            this.dismiss();
                        }
                        else {
                            this.view(savedBuyerNeed);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BuyerNeedsModal.prototype.showToast = function (message) {
        var toast = this.toastController.create({
            duration: TOAST_DURATION,
            message: message,
            showCloseButton: true
        });
        toast.present();
    };
    return BuyerNeedsModal;
}(BaseSlideModal));
export { BuyerNeedsModal };
